<template>
  <DsfFormControlBox
    class="ds-textbox"
    :owner="_self"
    :class="{
      'ds-textbox__has-prefix': !readOnly && valuePrefix,
      'ds-textbox-append-block__none': append && !isAppendGroup && !isAppendBackgroundColor
    }"
    allow-enter-focus
  >
    <template v-slot:simple v-if="inClient">
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <!-- <span v-if="value != ''">{{ append }}</span> -->
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content v-if="inClient">
      <template v-if="!readOnly">
        <template v-if="inputMode != 'step'">
          <div
            class="el-input"
            :class="{
              'ds-error-border': errors.length > 0,
              'is-disabled': disabled,
              'el-input-group': isPrefixGroup || isAppendGroup || append || valuePrefix,
              'el-input-group--prepend': isPrefixGroup,
              'el-input-group--append': isAppendGroup || append,
              'el-input--suffix': isSuffix,
              'el-input--prefix': isPrefix
            }"
          >
            <div class="ds-textbox-value-prefix" v-if="valuePrefix">{{ valuePrefix }}</div>
            <div class="el-input-group__prepend" v-if="isPrefixGroup">
              <slot name="prepend"></slot>
            </div>
            <input
              ref="input"
              v-model="inputValue"
              class="el-input__inner"
              :type="$inputType"
              :disabled="disabled"
              :placeholder="$t(placeholder)"
              :style="{ 'ime-mode': isNumberInput ? 'disabled' : 'auto' }"
              v-on="inputEventListener"
            />
            <span class="el-input__prefix" v-if="isPrefix">
              <slot name="prefix"></slot>
            </span>
            <span class="el-input__suffix" v-if="isSuffix">
              <span class="el-input__suffix-inner">
                <slot name="suffix"></slot>
              </span>
            </span>
            <div class="el-input-group__append" v-if="isAppendGroup || append">
              <slot name="append">
                {{ $t(append) }}
              </slot>
            </div>
          </div>
        </template>
        <template v-else>
          <StepTextBox
            v-model="inputValue"
            @focus="inputFocusHandler"
            @blur="inputBlurHandler"
            :disabled="disabled"
            :setp-template="setpTemplate"
            :split-char-in-value="false"
            :setp-input-temp="setpInputTemp"
          >
          </StepTextBox>
        </template>
      </template>
      <!--只读状态只显示div-->
      <div v-else class="ds-form-readonly">
        <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false"></DsfTextProxy>
        <!-- <span v-if="value != ''">{{ $t(append) }}</span> -->
      </div>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>
<script>
import textFilterRule from "./textFilterRule";
const StepTextBox = Vue.defineLazyComponent(() => require("./stepTextBox.vue"));
// let reg_number = /^[+-]?(\d|[1-9]\d+)(\.\d+)?$/g;
export default dsf.component({
  name: "DsfTextbox",
  mixins: [$mixins.formControl, textFilterRule],
  ctrlCaption: "文本框",
  components: {
    StepTextBox: StepTextBox
  },
  props: {
    lazyModel: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    //废弃，不再使用，请使用inputType
    ishideCon: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: "text"
    },
    isCheckStrength: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    isTrim: {
      type: Boolean,
      default: true
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("text-meta-data");
      }
    },
    append: {
      type: String,
      default: ""
    },
    isAppendBackgroundColor: {
      type: Boolean,
      default: true
    },
    emptyPlaceholder: {
      type: String,
      default: ""
    },
    valuePrefix: {
      type: String,
      default: ""
    },
    inputMode: {
      type: String,
      default: "normal" // text step
    },
    setpTemplate: {
      type: String,
      default: "xxxx-xxxx"
    },
    setpInputTemp: {
      type: String,
      default: "x"
    },
    // 值的纠错
    changeCorrection: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      bindInputValue: "",
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.bindInputValue;
      },
      set(v) {
        this.bindInputValue = v;
        if (!this.lazyModel) {
          this.emitValueChange(v);
        }
      }
    },
    $inputType() {
      return this.inputType == "password" ? "password" : "text";
    },
    isNumberInput() {
      if (this?.metadata?.valueAttributes?.[0]?.type?.value == "number") {
        return true;
      }
      return false;
    },
    inputEventListener() {
      let res = {
        change: this.inputChangeHandler,
        focus: this.inputFocusHandler,
        blur: this.inputBlurHandler
      };
      if (this.isNumberInput) {
        res["keydown"] = this.inputKeydownHandler;
        res["keyup"] = this.inputKeyupHandler;
      }
      return res;
    }
  },
  created() {
    let _this = this;
    Object.defineProperty(this, "isPrefixGroup", {
      get() {
        return _this.$slots.prepend;
      }
    });
    Object.defineProperty(this, "isAppendGroup", {
      get() {
        return _this.$slots.append;
      }
    });
    Object.defineProperty(this, "isPrefix", {
      get() {
        return _this.$slots.prefix;
      }
    });
    Object.defineProperty(this, "isSuffix", {
      get() {
        return _this.$slots.suffix;
      }
    });
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    $emitValueChange(v) {
      if (this.inputMode == "normal") {
        if (v && this.valuePrefix) {
          v = this.valuePrefix + v;
        } else if (this.valuePrefix && !v) {
          v = "";
        }
      }
      $mixins.formControl.methods.$emitValueChange.call(this, v);
    },
    focus() {
      this.inClient = true;
      this.$nextTick(() => {
        $(this.$el).find("input:visabled").get(0).focus();
      });
    },
    // keyupHandler(evt) {
    //   this.$dispatch("keyup", value);
    // },
    inputChangeHandler(e) {
      let value = this.filterValidNumber(e.target.value);
      value = this.filterFormat(value);
      //强制格式化输入值
      if (this?.changeCorrection?.command) {
        value = dsf.format(this.changeCorrection.command, value, this.changeCorrection.args || []);
      }
      if (this.lazyModel) {
        this.emitValueChange(value);
      } else {
        this.inputValue = value;
      }
      this.$nextTick(() => {
        this.emitFormValidate(value);
        this.$dispatch("change", value);
      });
    },
    inputBlurHandler() {
      this.$dispatch("blur");
    },
    inputFocusHandler() {
      this.$dispatch("focus");
    },
    filterValidNumber(value) {
      if (this.isNumberInput) {
        // reg_number.lastIndex = 0;
        // if (!reg_number.test(value)) {
        //   dsf.layer.message("请填写一个数字", false);
        //   return "";
        // }
        value = _.trim(value);
        if (!value) return "";
        if (value == "." || value == "-.") {
          return "0";
        }
        if (value.startsWith(".")) {
          return "0" + value;
        }
        if (value.startsWith("-.")) {
          return "-0" + value;
        }
        if (value.endsWith(".")) {
          return value.slice(0, -1);
        }
      }
      return value;
    },
    inputKeydownHandler(e) {
      if (!this.isNumberInput) return true;
      let key = e.key;
      let code = e.keyCode;
      var value = e.target.value;
      // console.log('↓', code, key);
      // tab、backspace、delete、↑→↓←,enter
      if ([9, 8, 46, 37, 38, 39, 40, 13].indexOf(code) > -1) {
        return true;
      }
      // 全选、剪切、复制、粘贴
      else if ([65, 88, 67, 86].indexOf(code) > -1) {
        if (e.ctrlKey) {
          return true;
        }
      }
      // 数字
      else if ((code >= 48 && code <= 57) || (code >= 96 && code <= 105)) {
        if (/^\d$/.test(key)) {
          return true;
        }
      }
      // 小数点
      else if (code == 190) {
        if (value.indexOf(".") == -1 && key == ".") {
          return true;
        }
      }
      // -
      else if (code == 189) {
        if (key == "-") {
          return true;
        }
      }
      e.preventDefault();
      return false;
    },
    inputKeyupHandler(e) {
      if (!this.isNumberInput) return true;
      let key = e.key;
      let code = e.keyCode;
      // console.log('↑', code, key);
      var value = e.target.value;
      if (!value.trim()) return true;
      value = value.match(/(^-)?([\d.])/g);
      if (!value) {
        e.target.value = "";
        return true;
      }
      value = value.join("").split(".");
      if (value.length > 1) {
        value.splice(1, 0, ".");
      }
      value = value.join("");
      e.target.value = value;
    }
  },
  watch: {
    value: {
      handler(v, ov) {
        if (this.inputMode == "normal") {
          if (this.valuePrefix && v) {
            v = v?.toString().replace(this.valuePrefix, "");
          }
        }

        this.bindInputValue = v;
      },
      immediate: true
    },
    isNumberInput(v) {
      if (v === true) {
        this.$emit("update:ishideCon", false);
        this.$emit("update:inputType", "number");
      }
    },
    inputType(v) {
      if (v == "password") {
        this.$emit("update:ishideCon", true);
      } else {
        this.$emit("update:ishideCon", false);
      }
    },
    ishideCon: {
      handler(v) {
        //兼容老组件得ishideCon属性
        if (v === true) {
          this.$emit("update:inputType", "password");
        } else if (this.isNumberInput) {
          this.$emit("update:inputType", "number");
        } else {
          this.$emit("update:inputType", "text");
        }
      },
      immediate: true
    }
  },
  destroyed() {
    // // console.log("text-box-destroyed")
    // if (this.$el && this.intersectionWatch && this?.$page?.intersectionObserverTextBoxElementsList) {
    //   this?.$page?.$removeFieldToViewIntersectionObserver?.(this);
    // }
  }
  // updated(){
  //   console.log("text-box-updated")
  // }
});
</script>
